export default {
    setStorage(state, storage) {
        state.storage = storage
    }
}